import React from 'react';
import { Backdrop, Bullseye, Spinner } from '@patternfly/react-core';
import './Loader.scss';
import { CustomSpinner } from './CustomSpinner';

type Props = {
	size?: 'lg' | 'md' | 'xl' | 'sm' | undefined;
	isFullScreen?: boolean;
	color?: string;
	isCustom?: boolean;
	customClass?: string;
};

function Loader(props: Props) {
	const { size, isFullScreen, isCustom, customClass } = props;

	if (isFullScreen) {
		return (
			<Backdrop style={{ zIndex: 10000000 }}>
				<Bullseye>
					<Spinner
						aria-label="Backdrop content"
						aria-valuetext="Loading..."
						size={size ?? 'xl'}
					/>
				</Bullseye>
			</Backdrop>
		);
	} else if (isCustom) {
		return (
			<div
				className="loader"
				data-testid="loader"
			>
				<CustomSpinner
					size="lg"
					color="white"
				/>
			</div>
		);
	} else {
		return (
			<div
				className="loader"
				data-testid="loader"
			>
				<Spinner
					className={customClass}
					size={size ?? 'xl'}
					color="black"
				/>
			</div>
		);
	}
}

export default Loader;
